import moment from 'moment';
import H_time from "@/helpers/time";

export default {
  setAnnounceAt(rawTime) {
    const nextOnTheHour = H_time.getNextOnTheHour();
    if (!rawTime) return H_time.setTimeToUtc(nextOnTheHour);
    const time = H_time.getDateDashFormat(rawTime, 'YYYY-MM-DD HH:mm:ssZ');
    const now = moment();
    return time === 'Invalid date' || !H_time.isAfter(rawTime, now)
      ? H_time.setTimeToUtc(nextOnTheHour)
      : H_time.setTimeToUtc(time);
  }
}